import React from 'react';
import { Shield } from 'lucide-react';

const TrustBanner = () => {
  return (
    <section className="py-6 bg-[#3D3D3D]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-center gap-4">
          <Shield size={24} className="text-[#C4B5A4]" strokeWidth={1.5} />
          <p className="font-inter text-sm md:text-base tracking-widest uppercase text-[#FAF8F5]">
            Expertise in Vendor Management & Production Strategy
          </p>
        </div>
      </div>
    </section>
  );
};

export default TrustBanner;
